import {defineStyleConfig} from '@chakra-ui/react'

import borders from '../foundations/borders'
import colors from '../foundations/colors'
import shadow from '../foundations/shadow'
import spacing from '../foundations/space'
import typography from '../foundations/typography'

const baseStyle = {
  alignItems: ['Top', 'Center'],
  padding: spacing['5xs'],
  bg: colors.background.contrast,
  borderRadius: borders.radii['2xs'],
  textColor: colors.text['contrast-primary'],
  shadow: shadow.xs,
  ...typography.textStyles.caption.medium,
}

const tooltipTheme = defineStyleConfig({baseStyle})

export default tooltipTheme
